<template>
  <v-card-actions class="py-0">
    <v-chip-group show-arrows column>
        <div v-for="(item, i) in steps">
          <v-chip
            class="nav-noclick"
            :key="i"
            :color="(subStep.id_step >= item.id) ? 'green darken-2' : 'gray'"
            :text-color="(subStep.id_step >= item.id) ? 'white' : 'gray'"
            :disabled="!(subStep.id_step == item.id)"
            :ripple="false"
          >
            CASE {{ i+1 }}
          </v-chip>
          <v-chip
            class="nav-noclick"
            v-if="subStep.id_step === item.id"
            color="green darken-2"
            text-color="white"
            :ripple="false"
            small
          >
            {{ subStep.label }}
          </v-chip>
        </div>
        <div>
      <v-chip
        :color="libraryAndCreditActives ? 'green darken-2' : 'gray'"
        :text-color="libraryAndCreditActives ? 'white' : 'gray'"
        :disabled="!libraryAndCreditActives"
        :ripple="!libraryAndCreditActives"
        @click="showLibrary()"
      >
        LIBRARY
      </v-chip>
      <v-chip
        :color="libraryAndCreditActives ? 'green darken-2' : 'gray'"
        :text-color="libraryAndCreditActives ? 'white' : 'gray'"
        :disabled="!libraryAndCreditActives"
        :ripple="!libraryAndCreditActives"
        @click="showCredits()"
      >
        CLAIM CREDIT
      </v-chip>
    </div>
    </v-chip-group>
  </v-card-actions>
</template>

<script>
import { mapMutations } from "vuex";
import caseConfigMixin from "/src/mixins/caseConfigMixin.js";

export default {
  name: "Stepper",
  mixins: [caseConfigMixin],
  props: {
    step: {
      type: Object,
      required: true,
    },
    subStep: {
      type: Object,
      required: true,
    },
    steps: {
      type: Array,
      required: true,
    },
    currentStep: {
      type: Number,
      required: true,
      default: 1,
    },
  },
  computed: {
    libraryAndCreditActives() {
      // Use config-based unlock logic from mixin
      return this.isLibraryCreditUnlocked(this.currentStep, this.subStep, this.steps);
    },
  },
  methods: {
    ...mapMutations(["setShowCredit", "setShowLibrary"]),
    showCredits() {
      this.setShowCredit(true);
    },
    showLibrary() {
      this.setShowLibrary(true);
    },
  },
};
</script>
<style>
  .bottom-stepper button {
    color: #ffffff !important;
  }
  .nav-noclick {
    cursor: initial;
  }
</style>